import React, { useState, useEffect } from "react";
import "./homePage.css";
import { Link } from "react-router-dom";
function Home() {
  // constants
  const [isSignIn, setIsSignIn] = useState(
    localStorage.getItem("isSignIn") === "true" || false
  );
  const [email, setEmail] = useState(localStorage.getItem("email") || "");
  const [username, setUsername] = useState(
    localStorage.getItem("username") || ""
  );
  useEffect(() => {
    const email = localStorage.getItem("email");
    const username = localStorage.getItem("username");
    if (email && username) {
      setIsSignIn(true);
    }
  }, []);
  const jumpToProfile = () => {
    window.location.href = "/Profile";
  };
  // return statement
  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <div className="navbar-logo">
            <h1>Chef's Kiss</h1>
          </div>
          <div className="navbar-user">
            <button
              className="btn btn-user"
              onClick={() => {
                jumpToProfile();
              }}
            >
              {username}
            </button>
            <button
              className="btn btn-logout"
              onClick={() => {
                setIsSignIn(false);
                setEmail("");
                setUsername("");
                window.location.href = "/ ";
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </nav>
      <div className="home-container">
        <header className="home-header">
          <h1>Welcome to My Cooking Website</h1>
        </header>
        <main className="home-main">
          <div className="home-main-container">
            <div className="home-main-item">
              <Link to="/chatgpt">
                <img src="recipe-maker.avif" alt="" />
                <div className="card">
                  <div className="card-title">
                    <h2>Recipe Maker</h2>
                  </div>
                  <div className="card-body">
                    <p>
                      This is a recipe maker . You can create your own recipe
                      and share it with others.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="home-main-item">
              <Link to="/Search">
                <img src="recipe-search.png" alt="" />
                <div className="card">
                  <div className="card-title">
                    <h2>Recipe Search</h2>
                  </div>
                  <div className="card-body">
                    <p>
                      This is a recipe search website. You can search for
                      recipes based on ingredients.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
            <div className="home-main-item">
              <Link to="/Explore">
                <img src="explore.jpg" alt="" />
                <div className="card">
                  <div className="card-title">
                    <h2>Explore</h2>
                  </div>
                  <div className="card-body">
                    <p>
                      This is a recipe explore website. You can explore other
                      people's recipes and like them.
                    </p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </main>

        <footer className="home-footer">
          <p>© 2023 My Cooking Website. All Rights Reserved.</p>
        </footer>
      </div>
    </>
  );
}
export default Home;
